import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { CloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import styled from 'styled-components';

const TITLE_WIDTH = {
  belowSm: '136px',
  sm: '220px',
  md: '280px',
};

const SECTION_HEIGHT = {
  default: '509px',
  belowSm: '280px',
};

const IMAGE_WIDTH = '650px';
const IMAGE_MIN_WIDTH = {
  belowSm: '170px',
  sm: '430px',
};

export const StyledSectionContainer = styled(Box)`
  height: ${SECTION_HEIGHT.default};
  position: relative;
  z-index: 1;
  contain: strict;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  ${themeMediaQuery('below_sm')} {
    height: ${SECTION_HEIGHT.belowSm};
  }
`;

export const StyledSection = styled(Flex)`
  flex-direction: column;
  align-items: center;
  gap: ${themeSpace(1)};
`;

export const StyledBox = styled(Box)`
  position: relative;
  max-width: ${IMAGE_WIDTH};
  ${themeMediaQuery('below_sm')} {
    margin-top: auto;
    margin-bottom: auto;
    min-width: ${IMAGE_MIN_WIDTH.belowSm};
  }
  ${themeMediaQuery('sm')} {
    margin-top: auto;
    margin-bottom: auto;
    min-width: ${IMAGE_MIN_WIDTH.sm};
  }
  ${themeMediaQuery('md')} {
    margin-top: unset;
    margin-bottom: unset;
    min-width: ${IMAGE_WIDTH};
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  max-width: 100%;
  max-height: 100%;
  padding: ${themeSpace(7)} ${themeSpace(6)};
  ${themeMediaQuery('below_sm')} {
    padding: 0;
    height: 100%;
    width: 100%;
  }
  ${themeMediaQuery('tablet')} {
    padding: ${themeSpace(7)} ${themeSpace(6)};
  }
`;

export const StyledTitle = styled(Text)`
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  left: 50%;
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('featureCopy17')}
    line-height: ${themeSpace(6)};
    width: ${TITLE_WIDTH.belowSm};
  }
  ${themeMediaQuery('tablet')} {
    ${themeVariant('dek24')}
    width: ${themeSpace(14)};
  }
  ${themeMediaQuery('sm')} {
    ${themeVariant('hed32')}
    width: ${TITLE_WIDTH.sm};
  }
  ${themeMediaQuery('md')} {
    width: ${TITLE_WIDTH.md};
    ${themeVariant('hed40')}
  }
  ${themeMediaQuery('xl')} {
    ${themeVariant('hed56')}
    width:${themeSpace(16)};
  }
`;

export const StyledContainer = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  gap: ${themeSpace(5)};
  padding-left: ${themeSpace(7)};
  padding-right: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    padding: ${themeSpace(5)};
    min-width: 50%;
    gap: ${themeSpace(3)};
  }
`;

export const StyledButtonContainer = styled(Flex)`
  gap: ${themeSpace(9)};
  margin-top: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    gap: ${themeSpace(4)};
    flex-wrap: wrap;
    display: none;
  }
  ${themeMediaQuery('sm')} {
    gap: ${themeSpace(5)};
  }
  ${themeMediaQuery('md')} {
    gap: ${themeSpace(9)};
  }
`;

export const StyledButton = styled(Button)`
  ${themeMediaQuery('below_sm')} {
    padding: 0 ${themeSpace(4)};
  }
`;

export const StyledFeature = styled(Text)`
  margin-left: ${themeSpace(6)};
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('caption')}
    margin-left: ${themeSpace(4)};
  }
  ${themeMediaQuery('tablet')} {
    ${themeVariant('featureCopy17')}
  }
`;

export const StyledButtonContainerMobile = styled(Flex)`
  gap: ${themeSpace(5)};
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;
